<template>
  <div id="register-config-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>登録情報設定</h2>
      </div>
      <div class="data-area" v-if="corpInfo && Object.keys(corpInfo).length > 0">
        <div class="error_message">{{ errorMessage.text }}</div>
        <ul>
          <li>
            <span class="label">企業名</span>
            <div>{{corpInfo.corpName}}</div>
          </li>
          <li>
            <span class="label">略称企業名<span class="count_limit">(半角16文字以内)</span></span>
            <div>{{corpInfo.corpNameShort}}</div>
          </li>
          <li>
            <span class="label">郵便番号</span>
            <input type="text" v-model="postcd" @keypress="validateNumber"
              @input="postcd=inputRestNumber($event)" maxlength="7" placeholder="郵便番号"/>
          </li>
          <li>
            <span class="label">都道府県</span>
            <input type="text" v-model="state" placeholder="住所">
          </li>
          <li>
            <span class="label">市区町村</span>
            <input type="text" v-model="city" placeholder="住所">
          </li>
          <li>
            <span class="label">その他住所/番地</span>
            <input type="text" v-model="street" placeholder="住所">
          </li>
          <li>
            <span class="label">電話番号</span>
            <input type="text" v-model="tel" @keypress="validateNumber"
              @input="tel=inputRestNumber($event)" maxlength="16" placeholder="電話番号">
          </li>
          <li>
            <span class="label">FAX</span>
            <input type="text" v-model="fax" @keypress="validateNumber"
             @input="fax=inputRestNumber($event)" maxlength="16" placeholder="FAX">
          </li>
        </ul>
        <div>※企業名および略称企業名の変更をご希望の方は<br>お問合せよりご連絡ください</div>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['postcd'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['state'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['city'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['street'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['tel'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['fax'] }}</p>
      <div class="button-area">
      <button type="button" class="main_btn" @click="onUpdate">設定</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import * as FormUtil from '../../utils/FormUtil'
import * as Check from '../../utils/Check'
import {API_URL} from '../../constants/App'
export default {
  name: 'RegisterConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 企業情報 */
      corpInfo: {},
      postcd: null,
      state: null,
      city: null,
      street: null,
      tel: null,
      fax: null,
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** inputの数字チェック */
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    /** inputに数字のみ許容 */
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    onUpdate: function () {
      let payload = {
        postcd: this.postcd,
        state: this.state,
        city: this.city,
        street: this.street,
        tel: this.tel,
        fax: this.fax
      }
      axios.post(API_URL.ADMIN + '/update-corp', payload
      ).then(response => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    getCorp: function () {
      axios.get(API_URL.ADMIN + '/get-corp'
      ).then(response => {
        this.corpInfo = response.data.data
        this.postcd = this.corpInfo.postcd
        this.state = this.corpInfo.state
        this.city = this.corpInfo.city
        this.street = this.corpInfo.street
        this.tel = this.corpInfo.tel
        this.fax = this.corpInfo.fax
      }).catch(error => {
        Api.handleError(error)
      })
    }
  },
  created: function () {
    this.getCorp()
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .error_message{
    padding: 0px;
    width: auto;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
.count_limit{
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/CorpInfoModal.vue